export default "__VITE_ASSET__BW0ILaHN__"